import React, { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useDispatch } from "react-redux";
import {
  getClausesCategoryTypeList,
  GetClauseTypeList,
} from "@/redux/Masters/clause/actions";

const UserModal = ({
  open,
  onClose,
  formData,
  errors,
  handleInputChange,
  onSave,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!open) return;
    dispatch(getClausesCategoryTypeList());
    dispatch(GetClauseTypeList());
  }, [open, dispatch]);

  if (!open) return null;

  const inputClass =
    "w-full rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 px-3 py-2 text-sm text-gray-800 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-sky-500";

  const labelClass =
    "text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1 block";

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
        <motion.div
          initial={{ opacity: 0, y: 30, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 30, scale: 0.95 }}
          className="w-full max-w-6xl rounded-2xl bg-white dark:bg-gray-950 shadow-2xl overflow-hidden"
        >
          {/* HEADER */}
          <div className="flex justify-between items-center px-6 py-4 bg-sky-600 text-white">
            <h2 className="text-lg font-semibold">User Information</h2>
            <button onClick={onClose} className="text-2xl">
              ×
            </button>
          </div>

          {/* BODY */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 p-6 max-h-[80vh] overflow-y-auto">
            {/* LEFT SIDE (FIXED: NO EMPTY SPACE, COMPACT GRID) */}
            <div className="grid grid-cols-2 gap-4">
              {/* Full width fields */}
              <div className="col-span-2">
                <label className={labelClass}>
                  Office <span className="text-red-500">*</span>
                </label>
                <select
                  className={inputClass}
                  name="Office"
                  value={formData.Office}
                   onChange={handleInputChange}
                >
                  <option value="">SELECT OFFICE TYPE</option>
                  <option value="WISCONSIN">WISCONSIN</option>
                </select>
                {errors.Office && (
                  <p className="text-red-500 text-xs">{errors.Office}</p>
                )}
              </div>

              <div className="col-span-2">
                <label className={labelClass}>
                  Profit Center<span className="text-red-500">*</span>
                </label>
                <select
                  className={inputClass}
                  name="Profitcenter"
                  value={formData.Profitcenter}
                  onChange={handleInputChange}
                >
                  <option value="">SELECT PROFIT CENTER</option>
                  <option value="WISCONSIN">WISCONSIN</option>
                </select>
              </div>

              <div className="col-span-2">
                <label className={labelClass}>
                  Role<span className="text-red-500">*</span>
                </label>
                <select
                  className={inputClass}
                  name="Role"
                  value={formData.Role}
                  onChange={handleInputChange}
                >
                  <option value="">Select Role</option>
                  <option value="Admin User">Admin User</option>
                  <option value="Accounting User">Accounting User</option>
                  <option value="Operational User">Operational User</option>
                  <option value="Sales User">Sales User</option>
                </select>
              </div>

              {/* Two column inputs */}
              <div>
                <label className={labelClass}>
                  First Name<span className="text-red-500">*</span>
                </label>
                <input
                  className={inputClass}
                  name="firstname"
                  value={formData.firstname}
                  onChange={handleInputChange}
                />
                {errors.firstname && (
                  <p className="text-red-500 text-xs">{errors.firstname}</p>
                )}
              </div>

              <div>
                <label className={labelClass}>
                  Last Name<span className="text-red-500">*</span>
                </label>
                <input
                  className={inputClass}
                  name="lastname"
                  value={formData.lastname}
                  onChange={handleInputChange}
                />
                {errors.lastname && (
                  <p className="text-red-500 text-xs">{errors.lastname}</p>
                )}
              </div>

              <div>
                <label className={labelClass}>
                  Phone<span className="text-red-500">*</span>
                </label>
                <input
                  className={inputClass}
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                />
                {errors.phone && (
                  <p className="text-red-500 text-xs">{errors.phone}</p>
                )}
              </div>

              <div>
                <label className={labelClass}>
                  Email<span className="text-red-500">*</span>
                </label>
                <input
                  className={inputClass}
                  name="Email"
                  value={formData.Email}
                  onChange={handleInputChange}
                />
                {errors.Email && (
                  <p className="text-red-500 text-xs">{errors.Email}</p>
                )}
              </div>

              <div>
                <label className={labelClass}>
                  User ID<span className="text-red-500">*</span>
                </label>
                <input
                  className={inputClass}
                  name="Userid"
                  value={formData.Userid}
                  onChange={handleInputChange}
                />
                {errors.Userid && (
                  <p className="text-red-500 text-xs">{errors.Userid}</p>
                )}
              </div>

              <div>
                <label className={labelClass}>
                  Password<span className="text-red-500">*</span>
                </label>
                <input
                  className={inputClass}
                  type="Password"
                  name="Password"
                  value={formData.Password}
                  onChange={handleInputChange}
                />
                {errors.Password && (
                  <p className="text-red-500 text-xs">{errors.Password}</p>
                )}
              </div>

              {/* Admin Key */}
              <div className="col-span-2">
                <label className={labelClass}>
                  Admin Key<span className="text-red-500">*</span>
                </label>
                <div className="flex gap-2">
                  <input className={inputClass} />
                  <button className="px-4 rounded-lg bg-gray-200 dark:bg-gray-800">
                    ↻
                  </button>
                </div>
              </div>

              <div>
                <label className={labelClass}>
                  Pass Expiry<span className="text-red-500">*</span>
                </label>
                <input
                  className={inputClass}
                  type="date"
                  name="passexpiry"
                  value={formData.passexpiry}
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <label className={labelClass}>
                  Landing Page<span className="text-red-500">*</span>
                </label>
                <select
                  className={inputClass}
                  name="loadingpage"
                  value={formData.loadingpage}
                  onChange={handleInputChange}
                >
                  <option value="">Select</option>
                  <option value="Export">Export</option>
                  <option value="Import">Import</option>
                </select>
              </div>

              <div className="col-span-2">
                <label className={labelClass}>Disclaimer</label>
                <textarea className={inputClass} rows="3" />
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="space-y-4">
              <div className="p-4 rounded-xl border bg-gray-50 dark:bg-gray-900 dark:border-gray-800">
                <h3 className="text-sm font-semibold mb-3">User Status</h3>

                <div className="space-y-3">
                  {["Active Flag", "Sales Person", "Contact Person"].map(
                    (item, i) => (
                      <label
                        key={i}
                        className="flex items-center justify-between p-3 rounded-lg bg-white dark:bg-gray-950 border dark:border-gray-800"
                      >
                        <span className="text-sm">{item}</span>
                        <input
                          type="checkbox"
                          className="h-4 w-4 accent-sky-500"
                        />
                      </label>
                    ),
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* FOOTER */}
          <div className="flex justify-end gap-3 px-6 py-4 border-t dark:border-gray-800">
            <button onClick={onClose} className="px-5 py-2 rounded-lg border">
              Cancel
            </button>

            <button
              onClick={onSave}
              className="px-5 py-2 rounded-lg bg-sky-600 text-white"
            >
              Save
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default UserModal;
